import React, { useEffect, useState } from 'react';
import { Dropdown } from 'carbon-components-react';
import { useAppContext } from '../../../hooks/AppContext';
import { segmentTracking } from '../../../lib/tracker';
import { QuestionData } from 'src/apps/envizi-price-estimator/types';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import {
  createUseTranslation,
  convertToString,
} from '../../../../../common/hooks/widgets/useTranslation';
import { useEnviziSelector } from '../../../lib/redux/hooks';
import { ADDITIONAL_INDUSTRY_POINT } from 'src/apps/envizi-price-estimator/constant/spread';

export type stepProps = {
  isOpen: boolean;
  question?: QuestionData;
  compliance?: string;
  showPrice: boolean;
  q1Val?: number;
};

const Step1 = ({ isOpen, compliance, showPrice }: stepProps) => {
  const { appAction } = useAppContext();
  const AEMMessages = useEnviziSelector((state) => state.translations.messages);
  const useTranslation = createUseTranslation(messages, AEMMessages);
  const [value, setValue] = useState<option>({
    id: '',
    label: convertToString(useTranslation('q1_default_label', true)),
    point: 0,
    cookieValue: '',
  });

  type option = {
    id: string;
    label: string;
    point: number;
    cookieValue: string;
  };
  const handleDropdown = (value: option) => {
    appAction({
      type: 'answerSingle',
      answerId: value.id,
      answerValue: `${value.label}-${value.point} Cookie-${value.cookieValue}`,
    });
    setValue(value);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Industry Dropdwon',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({ type: 'next', queId: 'Q1' });
  };

  useEffect(() => {
    if (compliance === 'Yes') {
      appAction({
        type: 'answerSingle',
        answerId: value.id,
        answerValue: `${value.label}-${
          value.point + ADDITIONAL_INDUSTRY_POINT
        } Cookie-${value.cookieValue}`,
      });
    } else {
      appAction({
        type: 'answerSingle',
        answerId: value.id,
        answerValue: `${value.label}-${value.point} Cookie-${value.cookieValue}`,
      });
    }
  }, [compliance]);

  useEffect(() => {
    appAction({
      type: 'reset',
      answerId: '',
      answerValue: false,
    });
  }, []);

  const answers = [
    {
      id: 'Q1A1',
      label: convertToString(useTranslation('q1_option1', true)),
      point: 3.5,
      cookieValue: 'Government',
    },
    {
      id: 'Q1A2',
      label: convertToString(useTranslation('q1_option2', true)),
      point: 4.3,
      cookieValue: 'Hospitality',
    },
    {
      id: 'Q1A3',
      label: convertToString(useTranslation('q1_option3', true)),
      point: 4.3,
      cookieValue: 'Technology',
    },
    {
      id: 'Q1A4',
      label: convertToString(useTranslation('q1_option4', true)),
      point: 4.6,
      cookieValue: 'Finance',
    },
    {
      id: 'Q1A5',
      label: convertToString(useTranslation('q1_option5', true)),
      point: 4.7,
      cookieValue: 'Education',
    },
    {
      id: 'Q1A6',
      label: convertToString(useTranslation('q1_option6', true)),
      point: 4.8,
      cookieValue: 'Retail',
    },
    {
      id: 'Q1A7',
      label: convertToString(useTranslation('q1_option7', true)),
      point: 5.7,
      cookieValue: 'Industrial',
    },
    {
      id: 'Q1A8',
      label: convertToString(useTranslation('q1_option8', true)),
      point: 7.4,
      cookieValue: 'Manufacturing',
    },
    {
      id: 'Q1A9',
      label: convertToString(useTranslation('q1_option9', true)),
      point: 6,
      cookieValue: 'Real Estate',
    },
    {
      id: 'Q1A10',
      label: convertToString(useTranslation('q1_option10', true)),
      point: 11,
      cookieValue: 'Healthcare',
    },
    {
      id: 'Q1A11',
      label: convertToString(useTranslation('q1_option11', true)),
      point: 6.3,
      cookieValue: 'Other',
    },
  ];

  return isOpen ? (
    <div>
      <h3 className="label-heading padding_8">{useTranslation('q1_state')}</h3>
      <Dropdown
        ariaLabel="Dropdown"
        id="envizi-industry-dropdown"
        className="industry-dropdown"
        label={useTranslation('q1_default_label')}
        titleText={''}
        items={answers}
        disabled={showPrice}
        selectedItem={value}
        onChange={(e) => handleDropdown(e.selectedItem!)}
        light={true}
      />
    </div>
  ) : null;
};

export default Step1;
